import './BetbookUserHeader.less';
import './BetbookUserHeader.dark.less';

import React from 'react';
import UserProfileAvatarView from '../user-profile/views/UserProfileAvatarView';
import clsx from 'clsx';
import i18n from '../../common/i18n';
import { BetbookAnalysisHeaderProps } from './types';

export default function BetbookUserHeader({
    author,
    successRate,
    onProfileClick,
    ownPost
}: BetbookAnalysisHeaderProps) {
    const { avatarId, nickname } = author;
    const successRateRounded = Math.round(successRate * 10) / 10;
    return (
        <div className="betbook-user-header pb-10">
            <div
                className="flex betbook-user-header-author left"
                onClick={onProfileClick}
                data-atid="betbook-post-header-author"
            >
                <UserProfileAvatarView avatarId={avatarId} className="user-profile-post-avatar-box" />
                <div className="flex betbook-user-header-info">
                    <div className={clsx({ 'header-own-user': ownPost })}>{nickname}</div>
                    {successRateRounded ? (
                        <div className="header-success-stats-label">
                            <div>{successRateRounded ? i18n('nui.betbook.label.rank') : ''}</div>
                            <div
                                className={clsx('pl-3', {
                                    'header-success-stats-red': successRateRounded < 31,
                                    'header-success-stats-orange': successRateRounded >= 31 && successRateRounded < 61,
                                    'header-success-stats-green': successRateRounded >= 61,
                                    'header-success-stats-hidden': !successRateRounded
                                })}
                            >
                                {`${successRateRounded}%`}
                            </div>
                        </div>
                    ) : null}
                </div>
            </div>
        </div>
    );
}
